import React from 'react';
import { withRouteData } from 'react-static';
import { ContentContainer } from '@flow/components/ui';
import { IPost } from 'types/IPost';
import { IPosts } from 'types/IPosts';
import * as NavigationAction from '@flow/store/navigation/actions';
import { connect } from 'react-redux';
import SEOTags from "@flow/components/seo/SEOTags";

interface Props {
  appLanguage: IAppLanguage;
  lang_versions: LangVersions;
  post: IPost;
  posts: IPosts;
  _setLanguage: any;
}

class NewsDetail extends React.Component<Props> {

  componentWillMount() {
    const {
      appLanguage,
      _setLanguage,
      post: {
        lang_versions
      }
    } = this.props;

    _setLanguage({ appLanguage, lang_versions });
  }
  componentWillReceiveProps({
    appLanguage,
    post: {
      lang_versions,
    }
  }: Props) {
    const {
      _setLanguage,
    } = this.props;

    _setLanguage({ appLanguage, lang_versions });
  }

  render() {

    const {
      post,
    } = this.props;

    return (
      <ContentContainer>
        <SEOTags news={post} />
        <h2>{ post.title }</h2>
        <div dangerouslySetInnerHTML={{__html: post.content_group.content}} />
      </ContentContainer>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    _setLanguage: ({appLanguage, lang_versions }: ISetLanguage) => {
      dispatch(NavigationAction.setLanguage(appLanguage, lang_versions));
    }
  }
};

export default connect(
  null,
  mapDispatchToProps
)(withRouteData(NewsDetail));


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/news/detail/NewsDetail.tsx